import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as inputs from '../inputs'

const DOC = gql`
  query AdminAgentKnowledgeBaseFiles(
    $input: AdminAgentKnowledgeBaseFileListInput!
  ) {
    adminAgentKnowledgeBaseFiles(input: $input) {
      canDelete
      dataSourceId
      key
      knowledgeBaseId
      lastModifiedAt
      name
      sizeBytes
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AdminAgentKnowledgeBaseFilesQuery,
    readonly ents.core.agent.KnowledgeBase.Management.File[] | undefined,
    'adminAgentKnowledgeBaseFiles'
  >(
    'adminAgentKnowledgeBaseFiles',
    graphql.transformers.OUT.list(
      graphql.transformers.OUT.object({
        canDelete: transformers.PASS_THROUGH,
        dataSourceId: transformers.PASS_THROUGH,
        key: transformers.PASS_THROUGH,
        knowledgeBaseId: graphql.transformers.OUT.validate(
          transformers.PASS_THROUGH,
          ents.core.agent.KnowledgeBase.assertIsKnowledgeBase,
        ),
        lastModifiedAt: graphql.transformers.OUT.if(
          TypeChecker.isString,
          transformers.PASS_THROUGH,
          graphql.transformers.OUT.always(undefined),
        ),
        name: transformers.PASS_THROUGH,
        sizeBytes: transformers.PASS_THROUGH,
      }),
      { onNullish: 'remove' },
    ),
  ),
  [],
)

const EXECUTOR = graphql.createExecutor<
  graphql.schema.AdminAgentKnowledgeBaseFilesQuery,
  readonly ents.core.agent.KnowledgeBase.Management.File[],
  graphql.schema.AdminAgentKnowledgeBaseFilesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})

const INPUT_TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.agent.KnowledgeBase.Management.FileListInput,
    graphql.schema.AdminAgentKnowledgeBaseFileListInput
  >({
    dataSourceId: transformers.PASS_THROUGH,
    knowledgeBaseId: transformers.PASS_THROUGH,
    target: graphql.transformers.IN.nullable(inputs.target.TRANSFORMER),
  }),
)

/** Lists files for one exact private or shared management target. */
export function execute(
  input: ents.core.agent.KnowledgeBase.Management.FileListInput,
) {
  return EXECUTOR({
    input: INPUT_TRANSFORMER.getGqlFrom(input),
  })
}
